import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/uxp-photoshop/uxp-photoshop/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "installation"
    }}>{`Installation`}</h1>
    <p>{`You can install the UXP Developer Tools by clicking `}<a parentName="p" {...{
        "href": "https://creativecloud.adobe.com/apps/download/uxp-developer-tools"
      }}>{`here`}</a>{` or by following these steps:`}</p>
    <ul>
      <li parentName="ul">{`Launch Adobe Creative Cloud Application. If not installed, `}<a parentName="li" {...{
          "href": "https://creativecloud.adobe.com/apps/download/creative-cloud"
        }}>{`download and install Creative Cloud`}</a>{`.`}</li>
      <li parentName="ul">{`Sign in with your Adobe account if not already signed in.`}</li>
      <li parentName="ul">{`Click on `}<inlineCode parentName="li">{`All apps`}</inlineCode>{` section, and you should see "UXP Developer Tools" listed.
`}<span parentName="li" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1280px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "67.5%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "display": "block",
              "transition": "opacity 0.5s 0.5s",
              "pointerEvents": "none"
            }
          }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/photoshop/uxp/static/89dc401e116c5336d84691abd1098ec5/cb523/ccd-allapps-udt.webp 320w", "/photoshop/uxp/static/89dc401e116c5336d84691abd1098ec5/797b9/ccd-allapps-udt.webp 640w", "/photoshop/uxp/static/89dc401e116c5336d84691abd1098ec5/4b075/ccd-allapps-udt.webp 1280w", "/photoshop/uxp/static/89dc401e116c5336d84691abd1098ec5/f3ff0/ccd-allapps-udt.webp 1920w", "/photoshop/uxp/static/89dc401e116c5336d84691abd1098ec5/79bc7/ccd-allapps-udt.webp 2272w"],
              "sizes": "(max-width: 1280px) 100vw, 1280px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/photoshop/uxp/static/89dc401e116c5336d84691abd1098ec5/72799/ccd-allapps-udt.png 320w", "/photoshop/uxp/static/89dc401e116c5336d84691abd1098ec5/6af66/ccd-allapps-udt.png 640w", "/photoshop/uxp/static/89dc401e116c5336d84691abd1098ec5/21b4d/ccd-allapps-udt.png 1280w", "/photoshop/uxp/static/89dc401e116c5336d84691abd1098ec5/29114/ccd-allapps-udt.png 1920w", "/photoshop/uxp/static/89dc401e116c5336d84691abd1098ec5/a3a74/ccd-allapps-udt.png 2272w"],
              "sizes": "(max-width: 1280px) 100vw, 1280px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/photoshop/uxp/static/89dc401e116c5336d84691abd1098ec5/21b4d/ccd-allapps-udt.png",
              "alt": "Creative cloud",
              "title": "Creative cloud",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "opacity": "0",
                "transition": "opacity 0.5s",
                "color": "inherit",
                "boxShadow": "inset 0px 0px 0px 400px none",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
    `}</span></li>
      <li parentName="ul">{`Click on the `}<inlineCode parentName="li">{`Install`}</inlineCode>{` button for the `}<inlineCode parentName="li">{`UXP Developer Tools`}</inlineCode>{` card to start installation.`}</li>
    </ul>
    <h2 {...{
      "id": "launching-for-the-first-time"
    }}>{`Launching for the first time`}</h2>
    <p>{`When you launch the Developer Tool for the first time, you'll be prompted to enable Developer Mode. This is required in order for you to load plugins in development into Photoshop.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "60.9375%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/static/2bcb165b3bab5e3cfd9d66c589912143/cb523/devmode.webp 320w", "/photoshop/uxp/static/2bcb165b3bab5e3cfd9d66c589912143/797b9/devmode.webp 640w", "/photoshop/uxp/static/2bcb165b3bab5e3cfd9d66c589912143/4b075/devmode.webp 1280w", "/photoshop/uxp/static/2bcb165b3bab5e3cfd9d66c589912143/f3ff0/devmode.webp 1920w", "/photoshop/uxp/static/2bcb165b3bab5e3cfd9d66c589912143/a662b/devmode.webp 2560w", "/photoshop/uxp/static/2bcb165b3bab5e3cfd9d66c589912143/f5c21/devmode.webp 2824w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/static/2bcb165b3bab5e3cfd9d66c589912143/72799/devmode.png 320w", "/photoshop/uxp/static/2bcb165b3bab5e3cfd9d66c589912143/6af66/devmode.png 640w", "/photoshop/uxp/static/2bcb165b3bab5e3cfd9d66c589912143/21b4d/devmode.png 1280w", "/photoshop/uxp/static/2bcb165b3bab5e3cfd9d66c589912143/29114/devmode.png 1920w", "/photoshop/uxp/static/2bcb165b3bab5e3cfd9d66c589912143/c2d13/devmode.png 2560w", "/photoshop/uxp/static/2bcb165b3bab5e3cfd9d66c589912143/027f0/devmode.png 2824w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/photoshop/uxp/static/2bcb165b3bab5e3cfd9d66c589912143/21b4d/devmode.png",
            "alt": "Enable Developer Mode",
            "title": "Enable Developer Mode",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p>{`Once you click `}<inlineCode parentName="p">{`Enable`}</inlineCode>{`, elevated permissions will be requested, and you may be required to enter your password or approve an action from the Developer Tool.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1110px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "46.5625%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/static/230cd03695514ef184b0de4e59c57294/cb523/macos-elevated-permissions.webp 320w", "/photoshop/uxp/static/230cd03695514ef184b0de4e59c57294/797b9/macos-elevated-permissions.webp 640w", "/photoshop/uxp/static/230cd03695514ef184b0de4e59c57294/af9b4/macos-elevated-permissions.webp 1110w"],
            "sizes": "(max-width: 1110px) 100vw, 1110px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/static/230cd03695514ef184b0de4e59c57294/72799/macos-elevated-permissions.png 320w", "/photoshop/uxp/static/230cd03695514ef184b0de4e59c57294/6af66/macos-elevated-permissions.png 640w", "/photoshop/uxp/static/230cd03695514ef184b0de4e59c57294/73caa/macos-elevated-permissions.png 1110w"],
            "sizes": "(max-width: 1110px) 100vw, 1110px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/photoshop/uxp/static/230cd03695514ef184b0de4e59c57294/73caa/macos-elevated-permissions.png",
            "alt": "Elevated Permissions request",
            "title": "Elevated Permissions request",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p>{`If you have problems with this step, you can also configure Developer Mode manually, although you must have Administrative privileges to do so:`}</p>
    <ul>
      <li parentName="ul">{`Quit the UXP Developer Tool`}</li>
      <li parentName="ul">{`Navigate to `}<inlineCode parentName="li">{`/Library/Application Support/Adobe/UXP/Developer`}</inlineCode>{` on macOS, or `}<inlineCode parentName="li">{`%CommonProgramFiles%/Adobe/UXP/Developer`}</inlineCode>{` on Windows. (If the folder does not exist, you can create it -- you'll need administrative rights.)`}</li>
      <li parentName="ul">{`Create a new file named `}<inlineCode parentName="li">{`settings.json`}</inlineCode>{` with the following contents (You'll need administrative rights to save the file):`}
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-json"
          }}>{`{"developer" : true}
`}</code></pre>
      </li>
      <li parentName="ul">{`Launch the UXP Developer Tool again.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      